import React from "react";
import { cellGrow } from "constants/styles";
import { DIMENSIONS } from "utils/constants/image";
import { useCtxReferences } from "utils/selectors";
import { interpolateRouteWithParams } from "utils/route";
import PATHS from "utils/paths";
import { SHORT_LINK } from "utils/constants/models";
import kebabCase from "lodash/kebabCase";
import ClickWrapper from "components/ClickWrapper";
import CopyToClipboard from "components/CopyToClipboard";
import CounterBezel from "components/CounterBezel";
import { PRIORITY_FILL } from "utils/constants/ui";
import { getIconForUID } from "components/FormerEditor/utils";
import Image from "components/Image";
import classnames from "classnames";
import { useShortLinkCheckoutResourceUrl } from "utils/shortLink";

const ShortLinkCell = ({ model, isFirst, isLast, isActive, onClick }) => {
  const {
    uuid,
    title,
    formattedValue,
    discount,
    shortId,
    previewUrl,
    service,
    images
  } = model;
  const { application } = useCtxReferences();

  const copyShortLink = useShortLinkCheckoutResourceUrl(shortId);
  const href = interpolateRouteWithParams(PATHS.HUB_APPLICATIONS_LINKS_SHOW, {
    application,
    [kebabCase(SHORT_LINK)]: {
      uuid: uuid
    }
  });

  const DiscountIcon = getIconForUID("discount");

  return (
    <div className="hairline-1 shadow-0 ba br2 bg-white w-100 relative cell-grow">
      <div className="flex flex-column justify-between">
        <ClickWrapper id={uuid} href={href} onClick={onClick}>
          <div className="pv2 flex flex-column justify-between pointer">
            {title && (
              <div className="flex flex-column justify-between ph2">
                <div className="f4 pb1 fw6 lh-title word-break truncate">
                  {title}
                </div>
              </div>
            )}
            <div
              style={{ height: DIMENSIONS.PRODUCT_CELL.height }}
              className={classnames(
                "flex flex-row pointer w-100 overflow-hidden relative",
                {
                  "bt hairline-1": title
                }
              )}
            >
              <CounterBezel count={images && images.length}>
                <Image
                  src={images && images[0]}
                  alt={title}
                  {...PRIORITY_FILL}
                />
              </CounterBezel>
            </div>
            {discount && (
              <div
                style={{ top: 46, left: 8 }}
                className="pa2 bg-white br2 flex flex-row absolute z-1 hairline-1 ba flex-shrink-0"
              >
                <DiscountIcon size={14} />
                <div className="pl1 f6 fw5 black-80">{discount}</div>
              </div>
            )}
          </div>
        </ClickWrapper>
        <div style={{ height: 33 }} className="w-100"></div>
        <div className="absolute bottom-0 right-0 left-0 z-1 center flex flex-column justify-end items-center w-100 bt hairline-1 pa2 bg-white-80 f6">
          <div className="pb2 flex w-100 items-center justify-end">
            <div className="f3 fw6">{formattedValue}</div>
          </div>
          <div className="w-100 pt2 bg-white">
            <CopyToClipboard
              tooltip="Copy link"
              toast="Copied link to clipboard"
              value={copyShortLink}
              customClasses={{
                tooltip: {
                  children: "flex pointer justify-end"
                }
              }}
            >
              <div className="f7 color-primary fw5 pr2">{shortId}</div>
            </CopyToClipboard>
          </div>
        </div>
      </div>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

export default ShortLinkCell;
